import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';

const ContactForm = (props) => {
    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });

    const [popup, setPopup] = useState({ show: false, message: '', type: '' });

    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async e => {
        e.preventDefault();
        if (validator.allValid()) {
            try {
                let res = await fetch("https://formspree.io/f/mzzjgazb", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(forms)
                });

                if (res.ok) {
                    showPopup("Message sent successfully!", "success");
                    setForms({ name: '', email: '', subject: '', phone: '', message: '' });
                    validator.hideMessages();
                } else {
                    showPopup("Failed to send message. Try again!", "error");
                }
            } catch (err) {
                console.error(err);
                showPopup("Something went wrong. Please try later.", "error");
            }
        } else {
            validator.showMessages();
        }
    };

    // ✅ Function to show popup and auto close after 3s
    const showPopup = (message, type) => {
        setPopup({ show: true, message, type });
        setTimeout(() => {
            setPopup({ show: false, message: '', type: '' });
        }, 3000);
    };

    return (
        <div className="wpo-contact-form-area">
            {/* ==== Popup ==== */}
            {popup.show && (
                <div className={`popup-message ${popup.type}`}>
                    <p>{popup.message}</p>
                </div>
            )}

            {/* ==== Form ==== */}
            <form className="contact-validation-active" onSubmit={submitHandler}>
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div className="form-field">
                            <input
                                value={forms.name}
                                type="text"
                                name="name"
                                className="form-control"
                                onBlur={changeHandler}
                                onChange={changeHandler}
                                placeholder="Your Name*" />
                            {validator.message('name', forms.name, 'required|alpha_space')}
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-field">
                            <input
                                value={forms.email}
                                type="email"
                                name="email"
                                className="form-control"
                                onBlur={changeHandler}
                                onChange={changeHandler}
                                placeholder="Your Email*" />
                            {validator.message('email', forms.email, 'required|email')}
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-field">
                            <input
                                value={forms.phone}
                                type="text"
                                name="phone"
                                className="form-control"
                                onBlur={changeHandler}
                                onChange={changeHandler}
                                placeholder="Your Phone*" />
                            {validator.message('phone', forms.phone, 'required')}
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-field">
                            <select
                                onBlur={changeHandler}
                                onChange={changeHandler}
                                value={forms.subject}
                                className="form-control"
                                name="subject">
                                <option value="">Choose a Service</option>
                                <option>Web Development</option>
                                <option>Web Design</option>
                                <option>Graphic Designing</option>
                                <option>Search Engine Optimization</option>
                            </select>
                            {validator.message('subject', forms.subject, 'required')}
                        </div>
                    </div>
                    <div className="fullwidth">
                        <div className="form-field">
                            <textarea
                                onBlur={changeHandler}
                                onChange={changeHandler}
                                value={forms.message}
                                name="message"
                                className="form-control"
                                placeholder="Message...">
                            </textarea>
                            {validator.message('message', forms.message, 'required')}
                        </div>
                    </div>
                </div>
                <div className="submit-area">
                    <button type="submit" className={props.btnClass}><span>Send Message</span></button>
                </div>
            </form>

            {/* ==== CSS for popup ==== */}
            <style jsx>{`
                .popup-message {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    background: #fff;
                    border-radius: 6px;
                    padding: 12px 18px;
                    font-weight: 500;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
                    z-index: 9999;
                    animation: fadeIn 0.3s ease-in-out;
                }
                .popup-message.success { border-left: 6px solid green; color: green; }
                .popup-message.error { border-left: 6px solid red; color: red; }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    )
}

export default ContactForm;
